import { lumi } from '@/lib/lumi'

const MAX_IMAGE_BYTES = 10 * 1024 * 1024
const ALLOWED_TYPES = new Set(['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'])

export function isHttpImageUrl(value: string): boolean {
  try {
    const parsed = new URL(value)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  }
  catch {
    return false
  }
}

export async function uploadTokenImage(file: File): Promise<string> {
  if (!ALLOWED_TYPES.has(file.type))
    throw new Error('Use a PNG, JPG, WEBP, or GIF image.')
  if (file.size > MAX_IMAGE_BYTES)
    throw new Error('Token image must be 10 MB or smaller.')

  const results = await lumi.tools.file.upload([file])
  const first = results[0]
  if (!first?.fileUrl)
    throw new Error(first?.uploadError || 'Could not upload token image.')
  return first.fileUrl
}
